import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/WhoWeAre.css';

// ✅ REPLACE THESE 3 VALUES WITH YOUR EMAILJS CREDENTIALS
const EMAILJS_SERVICE_ID  = 'service_no4n7g3';
const EMAILJS_TEMPLATE_ID = 'template_ziifrvj';
const EMAILJS_PUBLIC_KEY  = 'G_X1XutdISfcAuX1h';

const values = [
  {
    icon: '⭐',
    title: 'Quality',
    desc: 'Quality is the foundation of everything we manufacture. From raw material selection to final packaging, every process is carefully monitored to maintain purity, consistency, and superior product performance. Our commitment to excellence helps us deliver products trusted by domestic and international customers alike.'
  },
  {
    icon: '📊',
    title: 'Efficiency',
    desc: "Our strength lies in efficient manufacturing systems, advanced automatic plants, and organized operations that ensure smooth production with minimal resource waste. This allows us to deliver high-quality products with dependable supply capacity and cost-effective solutions for our customers."
  },
  {
    icon: '👍',
    title: 'Strong Relationships',
    desc: 'We believe long-term success is built on trust and strong partnerships. Over the years, we have developed reliable relationships with farmers, suppliers, distributors, and customers by maintaining transparency, quality commitment, and professional service at every stage of business.'
  },
  {
    icon: '➕',
    title: 'Trust & Reliability',
    desc: "Customer satisfaction is at the heart of our company values. We understand the importance of dependable quality, timely delivery, and consistent service. Through honesty, innovation, and continuous improvement, we aim to build lasting business relationships across India and global markets."
  },
];

const products = [
  {
    img: '/cl.png',
    label: 'Cutch / Catechu',
    images: [
      '/lightcutch.jpg',
      '/cutchblocks.jpg',
      '/darkcutch.jpg',
      '/LeatherGradeCatechu.jpg',
      '/SprayDriedCatechu.jpg',
      '/FoodGradeCutch.jpg',
    ],
    description: 'Cutch (Catechu) is a natural tannin extract derived from the heartwood of Acacia catechu. Used in leather tanning, textile dyeing, and various industrial applications.'
  },
  {
    img: '/al.png',
    label: 'Cutch Blocks',
    images: [
      '/acaciatanninpowder.jpg',
      '/finemeshacaciapowder.jpg',
      '/HerbalAcaciaPowder.jpg',
      '/HighPurityAcaciaPowder.jpg',
      '/FoodGradeAcaciaPowder.jpg',
      '/SprayDriedAcaciaPowder.jpg',
    ],
    description: 'Cutch Blocks is a natural gum derived from the Acacia tree. Widely used as a food additive, emulsifier, and binding agent in various industries.'
  },
  {
    img: '/ql.png',
    label: 'Quebracho Tannins',
    images: [
      '/NaturalQuebrachoExtract.jpg',
      '/SulphitedQuebracho.jpg',
      '/quebrachoextract1.png',
      '/UnsulphitedQuebracho.jpg',
      '/HighTanninQuebracho.jpg',
      '/LeatherGradeQuebracho.jpg',
    ],
    description: 'Quebracho Tannins are extracted from the Quebracho tree and are widely used in the leather tanning industry for their strong astringent properties.'
  },
  {
    img: '/il.png',
    label: 'Desi Katha',
    images: [
      '/PaanKatha.jpg',
      '/FoodGradeKatha.jpg',
      '/DarkKatha.jpg',
      '/PremiumKatha.jpg',
      '/KathaPowder.jpg',
      '/HerbalKatha1.png',
    ],
    description: 'Desi Katha is a natural extract from Acacia catechu used in traditional medicine, paan preparation, and as a natural dye and tanning agent.'
  },
  // ✅ NEW PRODUCT — Machine Katha
  {
    img: '/ml.png',
    label: 'Machine Katha',
    images: [
      '/ml.png',
      '/MachineKatha2.jpg',
      '/MachineKatha3.jpg',
      '/MachineKathaPowder.jpg',
      '/PremiumMachineKatha.jpg',
      '/FoodGradeMachineKatha.jpg',
    ],
    description: 'Machine Katha is a machine-processed, refined form of Katha manufactured under modern automated plants for uniform quality, purity, and consistency. It is widely used in paan masala, mouth fresheners, and food applications where standardized quality and hygienic processing are essential.'
  },
];

function ProductGalleryPage({ product, onClose }) {
  const [activeImg, setActiveImg] = useState(product.images[0]);

  return (
    <div className="gallery-overlay">
      <div className="gallery-page">

        {/* Header */}
        <div className="gallery-header">
          <h2 className="gallery-title">{product.label}</h2>
          <button className="gallery-close" onClick={onClose}>✕ Back</button>
        </div>

        {/* Main Image */}
        <div className="gallery-main">
          <img src={activeImg} alt={product.label} className="gallery-main-img" />
        </div>

        {/* Thumbnails */}
        <div className="gallery-thumbs">
          {product.images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`${product.label} ${i + 1}`}
              className={`gallery-thumb ${activeImg === img ? 'active' : ''}`}
              onClick={() => setActiveImg(img)}
            />
          ))}
        </div>

        {/* Description */}
        <div className="gallery-desc">
          <p>{product.description}</p>
        </div>

      </div>
    </div>
  );
}

function WhoWeAre() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  // ✅ Form state
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', subject: '', message: ''
  });
  const [isSending, setIsSending] = useState(false);
  const [statusMsg, setStatusMsg] = useState({ text: '', type: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ EmailJS submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatusMsg({ text: '', type: '' });

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
    };

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );
      setStatusMsg({ text: '✅ Message sent successfully! We will contact you soon.', type: 'success' });
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      console.error('EmailJS Error:', error);
      setStatusMsg({ text: '❌ Failed to send message. Please try again.', type: 'error' });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      {/* Product Gallery Page Overlay */}
      {selectedProduct && (
        <ProductGalleryPage
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
        />
      )}

      <div className="whoweare-wrapper">

        {/* LEFT SIDE */}
        <div className="whoweare-left">

          {/* Mission */}
          <div className="whoweare-section">
            <h3 className="section-heading">Our Mission:</h3>
            <p className="section-text">
              "At Sachin Kath Industries, our mission is to deliver premium-quality natural tannins and plant-based extracts that combine purity, performance, and sustainability. We are committed to supporting industries with reliable products, advanced manufacturing standards, and customer-focused solutions that create long-term value and trust."
            </p>
          </div>

          {/* Focus */}
          <div className="whoweare-section">
            <h3 className="section-heading">Our Vision & Focus:</h3>
            <p className="section-text">
              We continuously strive to achieve excellence through innovation, responsible sourcing, and quality-driven manufacturing. Our focus is to build strong partnerships with customers, suppliers, and global markets while maintaining consistent product standards and sustainable business growth.

              By combining traditional industry knowledge with modern technology, we aim to provide dependable natural extract solutions for leather tanning, herbal, food, and industrial applications worldwide.
            </p>
          </div>

          {/* Value Cards */}
          {values.map((item, index) => (
            <div className="value-card" key={index}>
              <div className="value-top">
                <h4>{item.title}</h4>
                <span className="value-icon">{item.icon}</span>
              </div>
              <p>{item.desc}</p>
            </div>
          ))}

        </div>

        {/* RIGHT SIDE */}
        <div className="whoweare-right">

          {/* Our Products */}
          <div className="sidebar-section">
            <h3 className="sidebar-title">OUR PRODUCTS</h3>
            <div className="products-grid">
              {products.map((p, i) => (
                <div
                  key={i}
                  className="product-item"
                  onClick={() => setSelectedProduct(p)}
                >
                  <img src={p.img} alt={p.label} />
                  <span className="product-label">{p.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Hear From Us */}
          <div className="sidebar-section">
            <h3 className="sidebar-title">Get Quick Answers, Contact Us</h3>

            <div className="call-box">
              <img src="/sklogo.png" alt="Sachin Kath Industries" />
              <div>
                <p>Call Us To Get Started:</p>
                <strong>+91-9665621383</strong>
              </div>
            </div>

            {/* ✅ Contact Form with EmailJS */}
            <form className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="subject"
                placeholder="Enter Subject"
                value={formData.subject}
                onChange={handleChange}
              />
              <textarea
                name="message"
                placeholder="Enter Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              {/* ✅ Status Message */}
              {statusMsg.text && (
                <p className={`whoweare-status-msg ${statusMsg.type}`}>
                  {statusMsg.text}
                </p>
              )}

              {/* ✅ Send Button with loading state */}
              <button className='btnwhoweare' type="subm
              it" disabled={isSending}>
                {isSending ? 'Sending...' : 'Send'}
              </button>
            </form>
          </div>

        </div>
      </div>
    </>
  );
}

export default WhoWeAre;